// extracted by mini-css-extract-plugin
export default {"content":"style_content__B5fYX","menu":"style_menu__guaAA"};